import React from 'react';
import { AuthServiceProvider } from '@trp-ta-nitro/auth-react';
import config from '../../config';

const ExternalAuthenticator = ({ children }) => {
  return (
    <AuthServiceProvider
      options={{
        apiKey: config('apiKey'),
        types: {
          external: {
            apiKey: config('apiKey'),
            requireAuthentication: false
          }
        }
      }}>
      {children}
    </AuthServiceProvider>
  );
};

export default ExternalAuthenticator;
